import { render, staticRenderFns } from "./ChoicePaymentInstalment.vue?vue&type=template&id=275d6222&scoped=true&"
import script from "./ChoicePaymentInstalment.vue?vue&type=script&lang=js&"
export * from "./ChoicePaymentInstalment.vue?vue&type=script&lang=js&"
import style0 from "./ChoicePaymentInstalment.vue?vue&type=style&index=0&id=275d6222&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275d6222",
  null
  
)

export default component.exports